module.exports = __webpack_public_path__ + "img/drone_02_H.efe44a0a.webp";